import moment from "moment";
import toast from "react-hot-toast";
import { translate } from "@vitalets/google-translate-api";

export const wrapperVariants = {
  open: {
    scaleY: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
    },
  },
  closed: {
    scaleY: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
    },
  },
};

export const limitText = (text: any, limit: number) => {
  return text?.length > limit ? text?.slice(0, limit) + "..." : text;
};

export const dateFormat = (data?: any) => {
  return moment(data).format("DD / MM / YYYY");
};

export const breakpoints = {
  0: {
    slidesPerView: 1,
  },
  400: {
    slidesPerView: 1,
  },
  639: {
    slidesPerView: 1,
  },
  865: {
    slidesPerView: 2,
  },
  1000: {
    slidesPerView: 3,
  },
  1500: {
    slidesPerView: 3,
  },
  1700: {
    slidesPerView: 3,
  },
};

export const breakpoints2 = {
  0: {
    slidesPerView: 1,
  },
  400: {
    slidesPerView: 1,
  },
  639: {
    slidesPerView: 1,
  },
  865: {
    slidesPerView: 2,
  },
  1000: {
    slidesPerView: 3,
  },
  1500: {
    slidesPerView: 4,
  },
  1700: {
    slidesPerView: 4,
  },
};

export const errorNotification = (message: any) => {
  //addToast(message, { autoDismiss: true, appearance: "error" });
  toast.error(message);
};
export const successNotification = (message: any) => {
  //addToast(message, { autoDismiss: true, appearance: "success" });
  toast.success(message);
};

export const formatPhoneNumber = (number: string): string => {
  if (!number) return "";
  // Remove any spaces for consistent processing
  const cleanedNumber = number.replace(/\s+/g, "");

  // Match the international code and the rest of the number
  const match = cleanedNumber.match(/^(\+?\d{3})(\d{3})(\d{3})(\d{3})$/);

  if (match) {
    // Format as (+243) 999 505 032
    return `(${match[1]}) ${match[2]} ${match[3]} ${match[4]}`;
  }

  // Return the original number if it doesn't match the format
  return number;
};

export function removeCircularReferences(obj: any) {
  const seen = new WeakSet();

  function remove(obj: any) {
    if (typeof obj === "object" && obj !== null) {
      if (seen.has(obj)) {
        return; // Circular reference found, so skip it
      }
      seen.add(obj);

      // Recursively remove circular references from nested properties
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          remove(obj[key]);
        }
      }
    }
    return obj;
  }

  return remove(obj);
}

export function deleteHtmlTagsAndImages(input: string): string {
  if(!input) return ""
  const noImages = input.replace(/<img[^>]*>/gi, "");
  return noImages.replace(/<\/?[^>]+(>|$)/g, "");
}

export async function autoTranslate(text: string, targetLang: string) {
  try {
    const res = await translate(text, { to: targetLang });
    return res.text;
  } catch (error) {
    console.error("Erreur de traduction :", error);
    return text;
  }
}
